import template from './advertEditPage.html';
import controller from './advertEditPage.controller';
import './advertEditPage.scss';

let advertEditPageComponent = {
  restrict: 'E',
  bindings: {
    linkTypes: '<',
    racedays: '<',
    locations: '<',
    nonRacingEvents: '<',
    advert: '<',
    socialMediaCategories: '<'
  },
  template,
  controller
};

export default advertEditPageComponent;
